export default Object.freeze({
  FETCH_SETTINGS_SUCCESS: 'FETCH_SETTINGS_SUCCESS',
  FETCH_SETTINGS_FAIL: 'FETCH_SETTINGS_FAIL',
  UPDATE_SETTINGS_SUCCESS: 'UPDATE_SETTINGS_SUCCESS',
  UPDATE_SETTINGS_FAIL: 'UPDATE_SETTINGS_FAIL',
  RESET_SETTINGS_NOTIFICATION: 'RESET_SETTINGS_NOTIFICATION',
});
